/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Contacttitle1Inputs */

const id_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Kami`)
};

const ms_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hubungi Kami`)
};

const da_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt Os`)
};

const de_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktieren Sie uns`)
};

const en_us2_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contact Us`)
};

const es_es2_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos`)
};

const es_mx2_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contáctanos`)
};

const fil_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Makipag-ugnayan sa Amin`)
};

const fr_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nous contacter`)
};

const it_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contattaci`)
};

const hu_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapcsolat`)
};

const nl_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neem contact op`)
};

const no_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt oss`)
};

const pl_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakt`)
};

const pt_br2_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contate-nos`)
};

const pt_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contacte-nos`)
};

const ro_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contactați-ne`)
};

const fi_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ota yhteyttä`)
};

const sv_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontakta oss`)
};

const vi_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liên hệ với chúng tôi`)
};

const tr_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bizimle İletişime Geçin`)
};

const cs_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kontaktujte nás`)
};

const bg_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свържете се с нас`)
};

const ru_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свяжитесь с нами`)
};

const uk_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зв'яжіться з нами`)
};

const ar_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اتصل بنا`)
};

const hi_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमसे संपर्क करें`)
};

const th_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ติดต่อเรา`)
};

const ja_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`お問い合わせ`)
};

const zh_cn2_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`联系我们`)
};

const zh_hant1_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`聯絡我們`)
};

const ko_about_contacttitle1 = /** @type {(inputs: About_Contacttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`문의하기`)
};

/**
* | output |
* | --- |
* | "Contact Us" |
*
* @param {About_Contacttitle1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_contacttitle1 = /** @type {((inputs?: About_Contacttitle1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Contacttitle1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_contacttitle1(inputs)
	if (locale === "ms") return ms_about_contacttitle1(inputs)
	if (locale === "da") return da_about_contacttitle1(inputs)
	if (locale === "de") return de_about_contacttitle1(inputs)
	if (locale === "en-US") return en_us2_about_contacttitle1(inputs)
	if (locale === "es-ES") return es_es2_about_contacttitle1(inputs)
	if (locale === "es-MX") return es_mx2_about_contacttitle1(inputs)
	if (locale === "fil") return fil_about_contacttitle1(inputs)
	if (locale === "fr") return fr_about_contacttitle1(inputs)
	if (locale === "it") return it_about_contacttitle1(inputs)
	if (locale === "hu") return hu_about_contacttitle1(inputs)
	if (locale === "nl") return nl_about_contacttitle1(inputs)
	if (locale === "no") return no_about_contacttitle1(inputs)
	if (locale === "pl") return pl_about_contacttitle1(inputs)
	if (locale === "pt-BR") return pt_br2_about_contacttitle1(inputs)
	if (locale === "pt") return pt_about_contacttitle1(inputs)
	if (locale === "ro") return ro_about_contacttitle1(inputs)
	if (locale === "fi") return fi_about_contacttitle1(inputs)
	if (locale === "sv") return sv_about_contacttitle1(inputs)
	if (locale === "vi") return vi_about_contacttitle1(inputs)
	if (locale === "tr") return tr_about_contacttitle1(inputs)
	if (locale === "cs") return cs_about_contacttitle1(inputs)
	if (locale === "bg") return bg_about_contacttitle1(inputs)
	if (locale === "ru") return ru_about_contacttitle1(inputs)
	if (locale === "uk") return uk_about_contacttitle1(inputs)
	if (locale === "ar") return ar_about_contacttitle1(inputs)
	if (locale === "hi") return hi_about_contacttitle1(inputs)
	if (locale === "th") return th_about_contacttitle1(inputs)
	if (locale === "ja") return ja_about_contacttitle1(inputs)
	if (locale === "zh-CN") return zh_cn2_about_contacttitle1(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_contacttitle1(inputs)
	return ko_about_contacttitle1(inputs)
});
export { about_contacttitle1 as "about.contactTitle" }